import React from 'react'
import PropTypes from 'prop-types'
import { Sparklines, SparklinesBars, SparklinesLine } from 'react-sparklines'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  background: white;
  padding: 2rem;
  margin-bottom: 2rem;
`
const Left = styled.div`
  flex: 1;
  width: 40%;
`
const Right = styled.div`
  flex: 1;
  margin-left: 2rem;
`
const Label = styled.div`
  font-size: 1.2rem; /* 85%; */
  color: #687077;
`
const Value = styled.div`
  font-size: 2rem;
  color: ${props => props.color};
`

class CardSparkline extends React.Component {
  render() {
    const { data, type, label, value, lineColor, textColor, style } = this.props

    return (
      <Container>
        <Left>
          <Sparklines data={data}>
            {
              type === 'line'
              ? <SparklinesLine color={lineColor} style={style}/>
            : <SparklinesBars style={{...style, fill: lineColor}}/>
            }
          </Sparklines>
        </Left>
        <Right>
          <Label>{label}</Label>
          {
            typeof value === 'object'  ? value : <Value color={textColor}>{value}</Value>
          }
        </Right>
      </Container>
    )
  }
}

CardSparkline.defaultProps = {
  data: [],
  type: 'line',
  label: 'label',
  value: 0,
  lineColor: 'red',
  style: {}
}

CardSparkline.PropTypes = {
  data: PropTypes.array,
  type: PropTypes.oneOf(['line', 'bar']),
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  lineColor: PropTypes.string,
  style: PropTypes.object,
  textColor: PropTypes.string
}

export default CardSparkline



// WEBPACK FOOTER //
// ./src/components/widgets/CardSparkline.js